import request from '@/utils/ajax'


export function saveMt4Config(data) {
    return request({
        url: '/wx/manage/mt4Receiver/save',
        method: 'post',
        data: data
    })
}

export function editMt4Config(data) {
    return request({
        url: '/wx/manage/mt4Receiver/update',
        method: 'put',
        data: data
    })
}

export function deleteMt4ChanelConfig(data) {
    return request({
        url: '/wx/manage/mt4Receiver/delete',
        method: 'post',
        data: data
    })
}
